import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function createReferral(): Promise<void> {
  try {
    await axios.post("/users/create-referral");
  } catch (error) {
    throwSylaApiError(error);
  }
}
